import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import { withRouter } from 'react-router';
import withProps from 'recompose/withProps';
import Link from 'react-router/lib/Link';
import { withPropsOnChange } from 'recompose';

import withCanViewWaitingList from '../../../common/hoc/withCanViewWaitingList';
import { isBarberUser } from '../../../auth/selectors';
import { belongsToShop } from '../selector';
import { redirectTo } from '../../../common/helpers/routerActions';
import { RoleAwareShop } from '../../../auth/roleAware';
import { canUserViewTimeReport } from '../../../common/helpers/users';
import withPermissions from '../../../auth/utils/withPermissions';
import { timeTrackingEnabled } from '../../timeTracker/selectors';
import { t } from '../../../../modules/infra/i18n';

const BarberLayout = ({ barberUser, barberId, children, canViewWaitingList, shouldShowTimeTracking }) => (
  <div className="u-max-width-1000 u-margin-auto">
    <ul className="layout layout--small layout--auto u-mv-">
      <li className="layout__item">
        <Link
          to={barberUser ? '/barber/profile' : `/barbers/${barberId}`}
          activeClassName="is-active"
          className="c-nav-tab"
          onlyActiveOnIndex
        >
          {t('barber:layout.tab.barber_details')}
        </Link>
      </li>
      <li className="layout__item" display-if={canViewWaitingList}>
        <Link
          to={barberUser ? '/barber/profile/waiting-list' : `/barbers/${barberId}/waiting-list`}
          activeClassName="is-active"
          className="c-nav-tab"
        >
          {t('barber:layout.tab.waiting_list')}
        </Link>
      </li>
      <li className="layout__item" display-if={shouldShowTimeTracking}>
        <RoleAwareShop>
          <Link
            to={`/barbers/${barberId}/time-tracking`}
            activeClassName="is-active"
            className="c-nav-tab"
          >
            {t('barber:layout.tab.time_tracking')}
          </Link>
        </RoleAwareShop>
      </li>
    </ul>
    {children}
  </div>
);
BarberLayout.propTypes = {
  barberId: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  barberUser: PropTypes.bool.isRequired,
  canViewWaitingList: PropTypes.bool.isRequired,
  shouldShowTimeTracking: PropTypes.bool.isRequired,
};

export default compose(
  withRouter,
  withPermissions,
  withProps(props => ({
    barberId: props.params.barberId,
  })),
  connect(
    (state, ownProps) => ({
      barberUser: isBarberUser(state),
      barberBelongsToShop: belongsToShop(state, ownProps.barberId),
      shouldShowTimeTracking: timeTrackingEnabled(state) && canUserViewTimeReport(ownProps.permissions),
    }),
    { redirectTo }
  ),
  withCanViewWaitingList,
  withPropsOnChange(
    ['barberBelongsToShop'],
    (props) => {
      if (!props.barberBelongsToShop && !props.barberUser) props.redirectTo('/');
    }
  ),
)(BarberLayout);
